import {
  JOB_APPLICATION_POSITION_SLUGS,
  type JobApplicationPositionSlug
} from '@algoacademy/backend/modules/notifications/job-application/constants'
import type { JobOffer } from './types'

/** List / header metadata only - offer body copy lives in ViewJobOffer/offers/*.tsx */
export const JOB_OFFERS: JobOffer[] = [
  {
    slug: 'mentor',
    positionName: 'Mentor',
    shortDescription:
      'Uczysz ambitnych uczniów programowania oraz zaawansowanej algorytmiki, mając bezpośredni wpływ na ich osiągnięcia, rozwój i\u00A0świadome kształtowanie dalszej ścieżki kariery w\u00A0branży IT.',
    isActive: true,
    salary: {
      uop: 'od 9 000 zł brutto',
      b2b: 'od 50% przychodu netto + VAT',
      uz: 'od 50% przychodu netto'
    }
  },
  {
    slug: 'mid-full-stack-engineer',
    positionName: 'Mid Software Engineer',
    shortDescription:
      'Budujesz nowoczesną platformę mentoringu end-to-end od baz danych, przez wydajne endpointy, aż po zaawansowany frontend oparty o\u00A0nasz dedykowany i\u00A0rozwijany design system.',
    isActive: false,
    salary: {
      uop: '9-12k brutto',
      b2b: '10-13k netto+VAT'
    }
  },
  {
    slug: 'junior-full-stack-engineer',
    positionName: 'Junior Software Engineer',
    shortDescription:
      'Dołączasz do product teamu i\u00A0uczysz się budować realne feature’y na produkcji, pracując wspólnie z\u00A0doświadczonym mentorem oraz poznając najlepsze praktyki kodowania.',
    isActive: true,
    salary: {
      uop: '6-8k brutto',
      uz: '31,50-40 zł/h brutto'
    }
  },
  {
    slug: 'ui-ux-designer',
    positionName: 'UI/UX Designer',
    shortDescription:
      'Projektujesz doświadczenia użytkownika dla uczniów oraz mentorów, biorąc odpowiedzialność za pełen proces produktowy od researchu aż po pełną spójność wizualną całego produktu.',
    isActive: false,
    salary: {
      uop: '8-11k brutto',
      b2b: '9-12k netto+VAT'
    }
  },
  {
    slug: 'marketing-specialist',
    positionName: 'Specjalista ds. Marketingu',
    shortDescription:
      'Rozwijasz strategię wzrostu platformy edukacyjnej IT, projektując lejki konwersji w\u00A0oparciu o\u00A0twarde dane oraz dbając o\u00A0content premium i\u00A0ekspercki, spójny głos marki.',
    isActive: false,
    salary: {
      uop: '10-13k brutto',
      b2b: '11-14k netto+VAT'
    }
  }
]

const offersBySlug = Object.fromEntries(JOB_OFFERS.map(offer => [offer.slug, offer])) as Record<
  JobApplicationPositionSlug,
  JobOffer
>

// Compile-time: every public slug has a full offer object.
const _allSlugsCovered: Record<JobApplicationPositionSlug, true> = {
  mentor: true,
  'mid-full-stack-engineer': true,
  'junior-full-stack-engineer': true,
  'ui-ux-designer': true,
  'marketing-specialist': true
}
void _allSlugsCovered
void JOB_APPLICATION_POSITION_SLUGS

export function getJobOfferBySlug(slug: string): JobOffer | undefined {
  if (!Object.hasOwn(offersBySlug, slug)) return undefined
  return offersBySlug[slug as JobApplicationPositionSlug]
}

/** Slugs currently open for applications (form select + apply CTA). */
export const ACTIVE_JOB_OFFER_SLUGS = JOB_OFFERS.filter(offer => offer.isActive).map(
  offer => offer.slug
) as JobApplicationPositionSlug[]

export function getJobOfferListItems() {
  return JOB_OFFERS.map(offer => ({
    slug: offer.slug,
    positionName: offer.positionName,
    description: offer.shortDescription,
    isActive: offer.isActive
  })).sort((a, b) => Number(b.isActive) - Number(a.isActive))
}
